var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ring"},[_c('div',{style:([{'border-width': _vm.borderWidth}])}),_vm._v(" "),_c('div',{style:([{'border-width': _vm.borderWidth}])}),_vm._v(" "),_c('div',{style:([{'border-width': _vm.borderWidth}])}),_vm._v(" "),_c('div',{style:([{'border-width': _vm.borderWidth}])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e3ae5dc","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/components/RingLoader.vue
// module id = 961
// module chunks = 1